export const sortRefs = (a = [], b = []) => {
  const aRefs = a.pub_med_references || [];
  const bRefs = b.pub_med_references || [];
  const lengthDiff = aRefs.length - bRefs.length;
  const stringDiff = aRefs.toString().localeCompare(bRefs.toString());
  return lengthDiff || stringDiff;
};

export const compareByProperty = (field) => {
  return (a, b) => {
    const x = typeof a?.[field] === "string" ? a[field].toLowerCase() : null;
    const y = typeof b?.[field] === "string" ? b[field].toLowerCase() : null;
    if (x === "" || x === null || x === undefined) return 1;
    if (y === "" || y === null || y === undefined) return -1;
    if (x === y) return 0;
    return x < y ? -1 : 1;
  };
};
